import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { NgxsModule } from '@ngxs/store';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { BalloonState } from '../shared/balloon-state/balloon.state';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createCustomMissingTranslationHandler, createTranslateLoader } from './app.component';
import { CustomHttpErrorInterceptor } from '@balloon-race-fullstack-monorepo/dbr-common';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([CustomHttpErrorInterceptor])),
    importProvidersFrom(
      NgxsModule.forRoot(
        [BalloonState],
        // {
        //   developmentMode: !environment.production,
        //   selectorOptions: {
        //     suppressErrors: false,
        //     injectContainerState: false
        //   }
        // }
      ),
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useFactory: createCustomMissingTranslationHandler
        },
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        }
      })
    )
  ],
};
